<div class="project"><img :src="image" :alt="title" rel="preload"></div>